import { useStore } from 'effector-react'
import { UnAuthProposalRegistrationDrawer } from '~/entities/Registration'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import { useDrawer } from '~/shared/ui/Drawer'
import { ArrowRightIcon } from '~/shared/ui/icons'
import { IconButton, Button, TextButton } from '../styled'

type LastInspectionButtonUnAuth = {
  taxiparkId?: UniqueId
}

export function LastInspectionButtonUnAuth({
  taxiparkId,
}: LastInspectionButtonUnAuth) {
  const [
    isBookingCarRegisterDrawerShow,
    openBookingCarRegisterDrawer,
    closeBookingCarRegisterDrawer,
  ] = useDrawer()

  const featureFlags = useStore(featureFlagModel.$featureFlags)
  const toPage = featureFlags.simplified_registration ? 'simplified' : 'full'

  return (
    <>
      <Button
        onClick={openBookingCarRegisterDrawer}
        variant='textLink'
        contentProps={{ style: { padding: '0' } }}
      >
        <TextButton>Посмотреть фото</TextButton>
        <IconButton>
          <ArrowRightIcon />
        </IconButton>
      </Button>

      <UnAuthProposalRegistrationDrawer
        isShow={isBookingCarRegisterDrawerShow}
        onCancel={closeBookingCarRegisterDrawer}
        taxiparkId={taxiparkId}
        descriptions='Для доступа к фотографиям выполните вход или пройдите регистрацию.'
        registrationType={toPage}
      />
    </>
  )
}
